import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import JobApplicationSection from './components/JobApplicationSection';
import ClientsSection from './components/ClientsSection';
import CTASection from './components/CTASection';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <AboutSection />
      <JobApplicationSection />
      <ClientsSection />
      <CTASection />
      <Footer />
    </main>
  );
}